<template>
  <div class="col-6 col-sm-4 col-lg-3 mb-3">
    <div class="card border-1 shadow text-left">
      <router-link :to="`/product/${product.id}`" class="text-dark">

        <div class="image-thumb" :style="{ backgroundImage: 'url('+thumbnail+')' }"></div>
        
        <div class="card-body">
          
          <h6 class="card-title  font-weight-light">
            {{product.title}}
          </h6>

          <div class="card-text">
            <!-- custom styled -->
            <span class="product-card-price font-weight-bold small">
              ₩{{parsedPrice}}
            </span>
          </div>

        </div>

      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Product',
  props: {
    product: {
      type: Object,
      default: function() { return{} },
    },
  },
  computed: {
    parsedPrice: function() {
      return this.product.price.toLocaleString();
    },
    thumbnail: function() {
      return this.product.imageUrls.split(',')[0];
    },
  },
}
</script>

<style scoped>
.image-thumb {
  width: 100%;
  padding-top: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>


// WEBPACK FOOTER //
// src/components/product/Product.vue